import 'polyfill-array-includes';
import  "primevue/resources/primevue.min.css";
import moment from "moment-timezone"
import axios from "axios";

const SelectPaymentTemplate = () => import("@/components/forms/payout/legacy/SelectPaymentTemplate.vue");


const SwiftSelector =  () => import("@/components/payout/SwiftSelector.vue");

const FeesCardsWarnings = () => import("@/views/pages/fees/FeesCardsWarnings.vue")
const RegistrationPage = () => import("@/views/pages/auth/RegistrationSetupPage.vue");

import {Certificate} from "@/models/verification/verification";

//const EthTransactionSearch = () => import("@/views/pages/finance/tools/EthTransactionSearch.vue");
const EthTransactionSearchNotice = () => import("@/views/pages/finance/tools/EthTransactionSearchNotice.vue");

const LegacyHistoryDocumentStatusIcon =
  () => import("@/views/pages/finance/legacy-history/LegacyHistoryDocumentStatusIcon.vue");
const LegacyHistoryDocumentControls = () =>
  import("@/views/pages/finance/legacy-history/LegacyHistoryDocumentControls.vue");
const DocumentStatusTitle = () => import("@/views/pages/finance/history/DocumentStatusTitle.vue");
const DocumentDetails = () => import("@/views/pages/finance/history/DocumentDetails.vue");
const DocumentBeneficiaryLink = () => import( "@/views/pages/finance/history/DocumentBeneficiaryLink.vue");
const DocumentBeneficiaryDetails = () =>
  import( "@/views/pages/finance/history/DocumentBeneficiaryDetails.vue");
const HistoryTable = () => import("@/views/pages/finance/history/HistoryTable.vue");


const WalletoKycResetWarningPayoutHint
  = () => import("@/views/pages/global/notices/WalletoKycResetWarningPayoutHint.vue");
const PayoutVerificationOtp = () => import("@/components/payout/verification/PayoutVerificationOtp.vue");
const PayoutVerificationPin = () => import("@/components/payout/verification/PayoutVerificationPin.vue");
const PayoutVerificationGooglecode = () => import("@/components/payout/verification/PayoutVerificationGooglecode.vue");
const PayoutVerificationTablecode = () => import("@/components/payout/verification/PayoutVerificationTablecode.vue");
const PayoutVerificationSignature = () => import("@/components/payout/verification/PayoutVerificationSignature.vue");
const PayoutVerificationNone = () => import("@/components/payout/verification/PayoutVerificationNone.vue");
const PayoutGroupVerificationType = () => import("@/components/payout/verification/PayoutGroupVerificationType.vue");
// import PayoutVerificationOtp from "@/components/payout/verification/PayoutVerificationOtp.vue";
// import PayoutVerificationPin from "@/components/payout/verification/PayoutVerificationPin.vue";
// import PayoutVerificationTablecode from "@/components/payout/verification/PayoutVerificationTablecode.vue";
// import PayoutVerificationSignature from "@/components/payout/verification/PayoutVerificationSignature.vue";
// import PayoutVerificationNone from "@/components/payout/verification/PayoutVerificationNone.vue";
// import PayoutGroupVerificationType from "@/components/payout/verification/PayoutGroupVerificationType.vue";


import RegularTabs from "@/components/decorations/RegularTabs.vue";
import RegularTabNavButton from "@/components/decorations/RegularTabNavButton.vue";
import RegularTab from "@/components/decorations/RegularTab.vue";
const HistoryBlock = () => import("@/views/pages/finance/history/LastHistoryBlock.vue");

const MerchantOrdersPage = () => import("@/views/pages/merchants/MerchantOrdersPage.vue");
const MerchantFinanceReportsPage = () => import("@/views/pages/merchants/MerchantFinanceReportsPage.vue");
const MerchantOrderDetailsPage = () => import("@/views/pages/merchants/MerchantOrderDetailsPage.vue");
const MerchantsListPage = () => import("@/views/pages/merchants/MerchantsListPage.vue");
const DepositMerchantOrder = () => import("@/views/pages/merchants/marketplace/DepositMerchantOrder.vue");
const DepositMerchantOrderCapitalist = () => import("@/views/pages/merchants/marketplace/DepositMerchantOrderCapitalist.vue");

const ReferralPageMaterials = () => import("@/views/pages/referral/ReferralPageMaterials.vue");
const ReferralPage = () => import("@/views/pages/referral/ReferralPage.vue");

// import CardsOfferPage from "@/views/pages/cards/ApplepayPublicOfferAgreement.vue";
const WalletoAgreementPage = () => import("@/views/pages/cards/WalletoAgreement.vue");

import HeaderBalance from "@/views/layouts/header/HeaderBalance.vue";
import CurrencyRates from "@/views/layouts/sidemenu/CurrencyRates.vue";


const LoginButton =  () =>  import("@/views/pages/auth/login/LoginButton.vue");

const LoginFormBlock = () => import("@/views/pages/auth/login/LoginFormBlock.vue");
const LoginPage = () => import("@/views/pages/auth/LoginPage.vue");

const CardsComparisonPage = () => import("@/views/pages/cards/CardsComparisonPage.vue");

import LegacyBootstrapDatepicker from "@/views/pages/basic/LegacyBootstrapDatepicker.vue";

import UsdtAddressesWindow from "@/views/pages/finance/accounts/crypto/UsdtAddressesWindow.vue";

import DropdownCryptoAddresses from "@/components/forms/dropdown/DropdownCryptoAddresses.vue";
import PayoutHintPanel from "@/components/forms/payout/PayoutHintPanel.vue";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import HorizontalPayoutFormGroup from "@/components/forms/horizontal/HorizontalFormGroup.vue";
// import DropdownAccounts from "@/components/forms/dropdown/DropdownAccounts.vue";
import {getI18n} from "@/components/legacy/legacy-core";



import PayoutDestinationCurrencyConversionNotice from "@/components/forms/payout/PayoutDestinationCurrencyConversionNotice.vue";
import PayoutDestinationCurrencyConversionNoticeFormGroup
  from "@/components/forms/payout/crypto/PayoutDestinationCurrencyConversionNoticeFormGroup.vue";

import InputAmount from "@/components/forms/payout/legacy/InputAmount.vue";
import PayoutInputAmountFormGroup from "@/components/forms/payout/PayoutInputAmountFormGroup.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import PayoutToggableHintPanel from "@/components/forms/payout/PayoutToggableHintPanel.vue";
import PayoutEvaluateFeeBlock from "@/components/forms/payout/PayoutEvaluateFeeBlock.vue";
import PayoutEvaluateFeeFormGroup from "@/components/forms/payout/PayoutEvaluateFeeFormGroup.vue";
import AutosplitDialogModal from "@/views/pages/finance/payout/AutosplitDialogModal.vue";
import PayoutFormWrapper from "@/views/pages/finance/payout/PayoutFormWrapper.vue";

const FrontofficeUserCategoryInlineSelect = () => import("@/views/pages/profile/FrontofficeUserCategoryInlineSelect.vue");


export const legacyFormsComponents = {
  DropdownCryptoAddresses,
  DropdownAccounts: PrimeDropdownAccounts,
  PrimeDropdownAccounts,
  PayoutHintPanel,
  PayoutFormGroup,
  PayoutFormPreloader,
  PayoutInputAmountFormGroup,
  HorizontalPayoutFormGroup,
  PayoutCryptoCurrencyNotice: PayoutDestinationCurrencyConversionNotice,
  PayoutCryptoCurrencyNoticeFormGroup: PayoutDestinationCurrencyConversionNoticeFormGroup,
  PayoutDestinationCurrencyConversionNotice,
  PayoutDestinationCurrencyConversionNoticeFormGroup,
  WalletoKycResetWarningPayoutHint,
  InputAmount,
  ErrorMessageBlock,
  PayoutInputHintBlock,
  PayoutToggableHintPanel,
  PayoutEvaluateFeeBlock,
  PayoutEvaluateFeeFormGroup,
  SwiftSelector,
  SelectPaymentTemplate
}

export const payoutFormComponents = {
  AutosplitDialogModal,

  'payout-form-evaluate-tax-group-cardtopup': PayoutCardTopUpEvaluateFeeFormGroup,
  'input-air-datepicker': PayoutDateInput,
  'input-cardnumber': PayoutCardnumberInput,
  'error-message': ErrorMessageBlock,
  'input-amount-group': PayoutInputAmountFormGroup,
  'dropdown-keyvalue': DropdownKeyValue,
  'hint-panel': PayoutHintPanel,
  'input-hint': PayoutInputHintBlock,
  'payout-hint-panel': PayoutHintPanel,
  'verification-type-group': PayoutGroupVerificationType,
  'hint-panel-form-group': PayoutHintPanelFormGroup,
  'toggable-hint-panel': PayoutToggableHintPanel,
  'toggable-hint-panel-form-group': PayoutToggableHintPanelFormGroup,
  'inputfield-text-group': PayoutTextfieldInputGroup,
  'estimated-destination-amount-group': PayoutEstimatedDestinationAmountFormGroup,
  'payout-form-evaluate-tax': PayoutEvaluateFeeBlock,
  'payout-form-evaluate-tax-group': PayoutEvaluateFeeFormGroup,
  'payout-form-notification': PayoutFormNotificationBlock,
  'filtered-input-wrapper': FilteredInputWrapper
}

import {CryptoAddress} from "@/models/finance/crypto";
import {Account} from "@/models/finance/account";
import {MoneyAmount} from "@/models/finance/money";
import {
  RemoteRequestState,
  RemoteRequestStatesEnum
} from "@/backoffice/components/pages/taxrules/taxrules";
import {CurrencyCode, frontofficeCurrencyFilter} from "@/models/core/currency";

const baseClasses = {
  CryptoAddress,
  Account,
  MoneyAmount,
  CurrencyCode,
  remote: {
    RemoteRequestState, RemoteRequestStatesEnum
  },
  PayoutWebModel,
  WebFormModel
}

import CurrencyBalanceSummaryCircle
  from "@/views/pages/finance/accounts/decorations/CurrencyBalanceSummaryCircle.vue";
import PayoutToggableHintPanelFormGroup
  from "@/components/forms/payout/hint/PayoutToggableHintPanelFormGroup.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import PayoutEstimatedDestinationAmountFormGroup
  from "@/components/forms/payout/forms/PayoutEstimatedDestinationAmountFormGroup.vue";
import PayoutFormNotificationBlock
  from "@/components/forms/payout/forms/PayoutFormNotificationBlock.vue";
import DropdownKeyValue from "@/components/forms/dropdown/DropdownKeyValue.vue";
import PayoutCardnumberInput from "@/components/forms/payout/forms/PayoutCardnumberInput.vue";
import PayoutHintPanelFormGroup from "@/components/forms/payout/hint/PayoutHintPanelFormGroup.vue";
import PayoutDateInput from "@/components/forms/payout/forms/PayoutDateInput.vue";
//import LegacyDropdownKeyvalue from "@/components/forms/dropdown/LegacyDropdownKeyvalue.vue";
import PayoutCardTopUpEvaluateFeeFormGroup
  from "@/components/forms/payout/fee/PayoutCardTopUpEvaluateFeeFormGroup.vue";
import FilteredInputWrapper from "@/components/forms/payout/forms/inputs/FilteredInputWrapper.vue";
import GooglecodeSettingsPage from "@/views/pages/security/GooglecodeSettingsPage.vue";
import GoogleCodeLogo from "@/components/forms/googlecode/GoogleCodeLogo.vue";
import ProfileUpdateRequiredCryptoNotice
  from "@/views/pages/finance/accounts/crypto/notice/ProfileUpdateRequiredCryptoNotice.vue";
import SecuritySetupThirdpartyAnalytics
  from "@/views/pages/security/setup/SecuritySetupThirdpartyAnalytics.vue";
import VerificationTypesPanel from "@/views/pages/security/setup/VerificationTypesPanel.vue";
import {FiltersMixin} from "@/backoffice/legacy/mixins/OldFilters";
import LegacyHeaderLangSwitcher from "@/views/layouts/header/LegacyHeaderLangSwitcher.vue";
import {Fingerprint} from "@/views/layouts/core/fingerprint";
import IntroAchievements from "@/views/pages/main/IntroAchievements.vue";
import HeaderAchievements from "@/views/pages/main/HeaderAchievements.vue";
import {
  DepositFormNotFound,
  DepositTypeSelect,
  DepositTypesMenu,
  LegacyProgressCircle,
  DepositTypesSelectDropdown,
  QiwiDepositBlock,
  MercuryoDepositBlock, WireDepositBlock, PayoutMenuLogo, DepositPageLoader
} from "@/frontoffice/deposit-components";
import {WebFormModel} from "capitalist-shared/src/core/model";
import PayoutFormPreloader from "@/components/forms/other/PayoutFormPreloader.vue";
import ProfileUpdateSelect from "@/views/pages/profile/ProfileUpdateSelect.vue";
import PrimeDropdownAccounts from "@/components/forms/dropdown/PrimeDropdownAccounts.vue";
import {PayoutWebModel} from "capitalist-shared/src/finance/payments";
const HistoryExportBlock = () => import ("@/components/history/HistoryExportBlock.vue");
const DepositEthereumPage = () => import("@/views/pages/finance/deposit/ethereum/DepositEthereumPage.vue");
//const ProfileUpdateSelect = () => import("@/views/pages/profile/ProfileUpdateSelect.vue");

const DepositUsdtTransferPage = () => import("@/views/pages/finance/deposit/usdt/DepositUsdtTransferPage.vue");
const DepositUsdcTransferPage = () => import("@/views/pages/finance/deposit/usdc/DepositUsdcTransferPage.vue");
const CopyAddressIcon = () => import("@/views/pages/finance/accounts/crypto/CopyAddressIcon.vue");
const DepositUsdViaQiwiPage = () => import("@/views/pages/finance/deposit/usdt/DepositUsdViaQiwiPage.vue");
const DepositBitcoinPage = () => import("@/views/pages/finance/deposit/bitcoin/DepositBitcoinPage.vue");
const DepositRoublesPage = () => import("@/views/pages/finance/deposit/rucards/DepositRoublesViaRucardsPage.vue");

const DepositUsdtCardtransferPage
  = () => import("@/views/pages/finance/deposit/usdt/DepositUsdtCardtransferPage.vue");
// const MerchantBlock = () => import("@/views/pages/merchants/orderpage/MerchantBlock.vue");
// const OrderBlock = () => import("@/views/pages/merchants/orderpage/OrderBlock.vue");
// const PaywaysBlock = () => import("@/views/pages/merchants/orderpage/PaywaysBlock.vue");
const QrcodeStyling = () => import("@/components/other/QrcodeStyling.vue");
const SupportReview = () => import("@/views/pages/support/SupportReview.vue");
const WalletoRefundAlert = () => import("@/views/pages/global/notices/walleto/WalletoRefundAlert.vue");



const GlobalNoticesBlock = () => import("@/views/pages/global/GlobalNoticesBlock.vue");


const verificationLegacyForms = {
  'verification-form-otp': PayoutVerificationOtp,
  'verification-form-pin': PayoutVerificationPin,
  'verification-form-googlecode': PayoutVerificationGooglecode,
  'verification-form-tablecode': PayoutVerificationTablecode,
  'verification-form-signature': PayoutVerificationSignature,
  'verification-form-none': PayoutVerificationNone,
  'payout-group-verification-type': PayoutGroupVerificationType,
}

const regularMixins = {
  'regular-tabs': RegularTabs,
  'regular-tab-nav-button': RegularTabNavButton,
  'regular-tab': RegularTab
}



const historyMixins = {
  'history-block': HistoryBlock,
  LegacyHistoryDocumentStatusIcon,
  LegacyHistoryDocumentControls,
  DocumentStatusTitle,
  HistoryTable,
  DocumentDetails,
  DocumentBeneficiaryLink,
  DocumentBeneficiaryDetails,
  // HistoryCsvDownloadButton,
  // HistoryAccountEntriesDownloadButton,
  HistoryExportBlock
}


const MerchantsMixins = {
  'merchant-orders-page': MerchantOrdersPage,
  'merchant-finance-reports-page': MerchantFinanceReportsPage,
  'merchant-order-details-page': MerchantOrderDetailsPage,
  'merchant-list-page': MerchantsListPage,
  'marketplace-merchant-account-deposit': DepositMerchantOrder,
  'marketplace-merchant-account-deposit-capitalist': DepositMerchantOrderCapitalist,
  // 'qrcode-styling': QrcodeStyling,
}

const Contacts = () => import("@/views/pages/contacts/Contacts.vue");
const BuyCryptoPage = () => import("@/views/pages/finance/deposit/BuyCryptoPage.vue");
const ContactsSocialsBlock = () => import( "@/views/pages/contacts/ContactsSocialsBlock.vue");

const ContactsMixins = {
  ContactsSocialsBlock,
  Contacts
};





const DepositMixins = {
  'finance-deposit-qiwi-block': QiwiDepositBlock,
  'finance-deposit-mercuryo-block': MercuryoDepositBlock,
  'finance-buy-crypto-page': BuyCryptoPage,
  DepositUsdtCardtransferPage,
  DepositUsdcTransferPage,
  DepositUsdtTransferPage,
  DepositBitcoinPage,
  DepositRoublesPage,
  DepositEthereumPage,
  DepositUsdViaQiwiPage,
  EthTransactionSearchNotice,
  'qrcode-styling': QrcodeStyling,


  DepositTypeSelect,
  DepositTypesMenu,
  DepositFormNotFound,
  LegacyProgressCircle,
  DepositTypesSelectDropdown,
  WireDepositBlock,
  PayoutMenuLogo,
  DepositPageLoader
}




export const core = {
  Certificate,
  verificationLegacyForms,
  baseClasses,
  core: {
    getI18n,
    Fingerprint
  },
  oldFiltersMixin: FiltersMixin,
  loginMixins: {
    components: {
      LoginFormBlock,
      LoginButton,
      LoginPage
    }
  },
  verificationLegacyMixin: {components: verificationLegacyForms},
  regularMixins: {components: regularMixins},
  legacyFormsMixins: {components: legacyFormsComponents},
  payoutMixins: {components: payoutFormComponents},
  historyMixins: {components: historyMixins},
  merchantMixins: {components: MerchantsMixins},
  referralMixins: {
    components: {
      'referral-page-materials': ReferralPageMaterials,
      ReferralPage
    }
  },
  icons: {
    GoogleCodeLogo
  },
  security: {
    GooglecodeSettingsPage,
    SecuritySetupThirdpartyAnalytics,
    VerificationTypesPanel
  },
  payout: {
    PayoutFormWrapper,
    //BasePayoutFormComponentFabrique
  },
  layoutMixins: {
    components: {
      HeaderBalance,
      'aside-currency-rates': CurrencyRates,
      GlobalNoticesBlock,
      WalletoRefundAlert,
      LegacyHeaderLangSwitcher,
      IntroAchievements,
      HeaderAchievements,
      FeesCardsWarnings
    }
  },
  pagesMixins: {
    components: {
      // CardsOfferPage
      WalletoAgreementPage,
      CardsComparisonPage,
      RegistrationPage,
      LegacyBootstrapDatepicker,
      UsdtAddressesWindow,
      SupportReview,
      ProfileUpdateSelect,
      FrontofficeUserCategoryInlineSelect
    }
  },
  accountsPageComponents: {
    CopyAddressIcon
  },
  accountsMixins: {
    components: {
      ProfileUpdateRequiredCryptoNotice,
      CurrencyBalanceSummaryCircle,
      CopyAddressIcon
    }
  },
  masspaymentFilters: {
    frontofficeCurrencyFilter
  },
  depositMixins: {
    components: DepositMixins
  },
  contactsMixins: {
    components: ContactsMixins
  }
};

moment.tz.setDefault("Europe/Moscow")

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-Agent': 'components-js',
}

export default core
